import request from '@/utils/request'
import qs from 'qs'

// 首页接口

/**
 * 根据id查询客户详情
 * @param {int} id 客户id
 */
export function getOrgFindById(id) {
	return request({
		url: `/index/org/findById`,
		method: 'get',
		params: { id }
	})
}
/**
 * 直播热点
 * @param {int} orgId 
 */
export function getHotSpotItem(orgId) {
	return request({
		url: `/index/item/hotSpotItem`,
		method: 'get',
		params: { orgId }
	})
}
/**
 * 获取项目列表
 * @param {int} pageNumber
 * @param {int} pageSize 
 * @param {int} orgId  用户id
 * @param {int} state  项目状态 0、未开始 1、直播中 2、结束 3、暂停 4、删除 5、过期
 * @param {String} keyword  关键字
 * @param {Boolean} isAsc  是否正序排序
 * @param {String} beginTime  开始时间
 * @param {String} endTime  结束时间
 * @param {int} provinceCode  省
 * @param {int} cityCode  市
 * @param {int} areaCode  县
 */
export function getItemList(pageNumber, pageSize, orgId, state, keyword, isAsc, beginTime, endTime, provinceCode, cityCode, areaCode) {
	return request({
		url: `/index/item/list`,
		method: 'get',
		params: { pageNumber, pageSize, orgId, state, keyword, isAsc, beginTime, endTime, provinceCode, cityCode, areaCode },
		paramsSerializer: params => {
			return qs.stringify(params, { indices: false })
		}
	}).then(res=>{ //处理，并返回新的res
		let arr = res.data.list
		if (arr) {
			arr.forEach(e => {
				e.id = e.cryptoId
				e.orgId = e.cryptoOrgId
				e.provinceCode = e.cryptoProvinceCode
				e.cityCode = e.cryptoCityCode
				e.areaCode = e.cryptoAreaCode
				e.roomId = e.cryptoRoomId
			});
		}
		return res
	})
}


// 直播接口
/**
 * 查询直播详情
 * @param {int} id 
 */
 export function liveFindById(id) {
	return request({
		url: `/index/live/findById`,
		method: 'get',
		params: { id }
	}).then(res=>{ //处理，并返回新的res
		let e = res.data
		if (e) {
			e.id = e.cryptoId
			e.orgId = e.cryptoOrgId
			e.provinceCode = e.cryptoProvinceCode
			e.cityCode = e.cryptoCityCode
			e.areaCode = e.cryptoAreaCode
			e.roomId = e.cryptoRoomId
		}
		return res
	})
}
/**
 * 查询直播状态
 * @param {int} id 项目id
 * @param {int} clientId 观看者id
 */
 export function liveFindStateById(id,clientId) {
	return request({
		url: `/index/live/findStateById`,
		method: 'get',
		params: { id,clientId }
	})
}

/**
 * 查找下级单位列表
 * @param {int} id 
 */
 export function findSubOrg(id) {
	return request({
		url: `/index/org/findSubOrg`,
		method: 'get',
		params: { id }
	})
}


// WEBPACK FOOTER //
// ./src/api/home.js